import React from 'react';

export default function AboutSection2() {
    return (
        <>
            <section className="quote-logistics position-relative">
                <div className="container" style={{maxWidth:"100%", paddingRight:0, paddingLeft: 0}}>
                    <div className="quoute-logistincs-wrapper position-relative">
                        <div className="row g4">
                            <div className="col-lg-6 col-md-8">
                                <div className="quote-content">
                                    <div className="section-title">
                                        <h1 className="n0-clr mb-xxl-6 mb-xl-5 mb-4 aos-init aos-animate"
                                            data-aos="zoom-in-right"
                                            data-aos-duration="1600"
                                            style={{
                                                fontSize: '3rem',
                                                fontWeight: '700',
                                                lineHeight: '1.2'
                                            }}>
                                            Driven Home Services, c'est pour qui ?
                                        </h1>

                                        <p className="n0-clr mb-xxl-8 mb-xl-7 mb-lg-6 mb-5 aos-init aos-animate"
                                           data-aos="zoom-in-left"
                                           data-aos-duration="1400"
                                           style={{
                                               textAlign: 'justify',
                                               fontSize: '1.25rem',
                                               lineHeight: '1.6',
                                               fontWeight: '400'
                                           }}>
                                            Chez Driven Home Services, tout le monde trouve son compte. Nous avons créé une plateforme inclusive où chacun peut prospérer, qu'il soit chercheur de services ou prestataire.
                                        </p>

                                        <p className="n0-clr mb-xxl-8 mb-xl-7 mb-lg-6 mb-5 aos-init aos-animate"
                                           data-aos="zoom-in-left"
                                           data-aos-duration="1400"
                                           style={{
                                               textAlign: 'justify',
                                               fontSize: '1.25rem',
                                               lineHeight: '1.6',
                                               fontWeight: '400'
                                           }}>
                                            Pour les familles, c'est simple : trouvez facilement une personne de confiance pour vos besoins domestiques, du gardiennage à l'aide ménagère. Pour les professionnels, nounous, tuteurs, aide-ménagères et pet sitters, c'est une opportunité d'emploi sans contrainte. Créez votre profil en minutes, fixez vos tarifs librement, et répondez aux annonces qui correspondent à vos compétences. Aucun intermédiaire, aucune démarche bureaucratique, aucune ambiguïté. Juste de la clarté et de la simplicité.
                                        </p>

                                        <p className="n0-clr mb-xxl-8 mb-xl-7 mb-lg-6 mb-5 aos-init aos-animate"
                                           data-aos="zoom-in-left"
                                           data-aos-duration="1400"
                                           style={{
                                               textAlign: 'justify',
                                               fontSize: '1.25rem',
                                               lineHeight: '1.6',
                                               fontWeight: '400'
                                           }}>
                                            La transparence est le fondement de notre approche. Consultez librement les évaluations, l'expérience et la disponibilité de chaque professionnel avant de prendre votre décision. Chaque membre de notre communauté peut avoir confiance dans les informations qu'il voit.
                                        </p>

                                        <p className="n0-clr mb-xxl-8 mb-xl-7 mb-lg-6 mb-5 aos-init aos-animate"
                                           data-aos="zoom-in-left"
                                           data-aos-duration="1400"
                                           style={{
                                               textAlign: 'justify',
                                               fontSize: '1.25rem',
                                               lineHeight: '1.6',
                                               fontWeight: '400'
                                           }}>
                                            Driven Home Services est la solution équitable où familles et prestataires trouvent exactement ce qu'ils recherchent, sans compromis.
                                        </p>

                                        {/*<div className="d-flex flex-wrap align-items-center gap-xxl-4 gap-xl-3 gap-2">
                                            <a href="contact.html"
                                               className="dhs-btn s1-border dhs-btn-alt overflow-hidden n900-clr d-inline-flex align-items-center gap-2 text-capitalize s1-bg py-xxl-4 py-3 px-xxl-8 px-lg-5 px-4 fw-500 aos-init aos-animate"
                                               data-aos="zoom-in-up"
                                               data-aos-duration="1500"
                                               style={{
                                                   fontSize: '1.1rem',
                                                   fontWeight: '600',
                                                   backgroundColor: '#1d8d36',
                                                   color:'white',
                                               }}>
                                                Obtenir un devis
                                                <span className="icons">
                                                    <i className="ph ph-arrow-up-right"></i>
                                                </span>
                                            </a>
                                            <a href="service-details.html"
                                               className="dhs-btn dhs-btn0 n0-border overflow-hidden n0-clr d-inline-flex align-items-center gap-2 text-capitalize py-xxl-4 py-3 px-xxl-8 px-lg-5 px-4 fw-500 aos-init aos-animate"
                                               data-aos="zoom-in-up"
                                               data-aos-duration="1700"
                                               style={{
                                                   fontSize: '1.1rem',
                                                   fontWeight: '600'
                                               }}>
                                                Nos services
                                            </a>
                                        </div>
                                    */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <img src="assets/images/element/quote-shape.png" alt="img" className="quote-shape aos-init aos-animate position-absolute"
                     style={{
                         top: '50%',
                         transform: 'translateY(-50%)',
                         borderRadius:'10%',
                     }}
                     data-aos="zoom-in-left" data-aos-duration="1500"/>
            </section>
        </>
    );
}